import ApiService from '@/api/service/ApiService.js';
const queryString = require('querystring')
var ReportService = {


    getReports: function($data)
    {
       return new Promise(function(resolve,reject) {

            var $options = {};
            $options.url = 'reports?'+queryString.stringify($data)
            $options.method="get"
            ApiService.request($options)
                .then(response => {
                    console.log(response)
                    resolve(response.data.data)
                }).catch(error =>{
                    reject(error)
                })

       });
    },
    getReportFilter: function($data)
    {
       return new Promise(function(resolve,reject) {
           var $options= {};
           $options.url ="reportFilter?"+queryString.stringify($data)
           $options.method="get"
           if(!$data) {
               $options.data = $data
           }
           ApiService.request($options)
               .then(response => {
                  // console.log('Gpt the data');
                   resolve(response.data.data)
               }).catch(error=> {
                   reject(error);
               })
       });

   },
    addReportToCompany:function($data) {
        return new Promise(function(resolve,reject) {

            var $options = {};
            $options.url = 'addReportToCompany'
            if($data) {
                $options.data = $data
            }
            $options.method="post"
            ApiService.request($options)
                .then(response => {
                    console.log(response)
                    resolve(response.data.data)
                }).catch(error =>{
                    reject(error)
                })

       });
    },
    removeFromCompany:function($data) {
        return new Promise(function(resolve,reject) {

            var $options = {};
            $options.url = 'removeFromCompany?'+queryString.stringify($data)
            if($data) {
                $options.data = $data
            }
            $options.method="delete"
            ApiService.request($options)
                .then(response => {
                    console.log(response)
                    resolve(response.data.data)
                }).catch(error =>{
                    reject(error)
                })

       });
    },
    getReportForCompany: function($data)
    {
       return new Promise(function(resolve,reject) {

            var $options = {};
            $options.url = 'reportsForCompany'
            if($data) {
                $options.url = $options.url+'?='+queryString.stringify($data)
            }
            $options.method="get"
            ApiService.request($options)
                .then(response => {
                    console.log(response)
                    resolve(response.data.data)
                }).catch(error =>{
                    reject(error)
                })

       });
    },
 
    getReportForCompany2: function($data)
    {
       return new Promise(function(resolve,reject) {

            var $options = {};
            $options.url = 'reportsForCompany2'
            if($data) {
                $options.url = $options.url+'?'+queryString.stringify($data)
            }
            $options.method="get"
            ApiService.request($options)
                .then(response => {
                    console.log(response)
                    resolve(response.data.data)
                }).catch(error =>{
                    reject(error)
                })

       });
    },
    getOne: function($id)
    {
       return new Promise(function(resolve,reject) {

            var $options = {};
            $options.url = 'reports/'+$id
            $options.method="get"
            ApiService.request($options)
                .then(response => {
                    console.log(response)
                    resolve(response.data.data)
                }).catch(error =>{
                    reject(error)
                })

       });
    },
    getColumnsForDataSet($id) {
        return new Promise(function(resolve,reject) {

            var $options = {};
            $options.url = 'reportColumns/'+$id
            $options.method="get"
            ApiService.request($options)
                .then(response => {
                    console.log(response)
                    resolve(response.data.data)
                }).catch(error =>{
                    reject(error)
                })

       });
    },
    create($data) { 
        return new Promise(function(resolve,reject) { 
        var $options= {}; 
         $options.url ='report' 
         $options.method='post' 
        //  $data.created_by = JSON.parse(localStorage.getItem('tiburaClinic')).data.User.id
        //  $data.modified_by = JSON.parse(localStorage.getItem('tiburaClinic')).data.User.id
         $options.data =$data
         ApiService.request($options) 
                 .then(response => {  
                 resolve(response.data.data) 
            }).catch(error=> { 
                reject(error);
            }) 
        });
    }, 
    update($data) { 
        return new Promise(function(resolve,reject) { 
        var $options= {}; 
        $options.url ='report/' +$data.id
        $options.method='post' 
        $options.data =$data
        ApiService.request($options) 
            .then(response => {  
                resolve(response.data.data) 
                }).catch(error=> { 
                reject(error);
            }) 
        });
    }
};
export default ReportService;